/**
 * 앱 미설치 or 앱링크 미지원인 상태면 web 으로 fallback 이 떨어집니다
 * 이때 쿼리파람으로 설정된 APP_LINK_FALLBACK_QUERY_KEY 를 통해 폴백 액션을 처리합니다
 */
export enum AppLinkFallbackType {
  /**
   * 웹에서 스킴을 지원한다면 해당 웹페이지가 뜹니다
   * 지원하지 않는다면 앱다운로드 페이지가 뜹니다(appdownload 참고)
   */
  Web = 'web',
  /**
   * 앱다운로드페이지가 뜹니다
   * 페이지가 뜬 뒤 scheme 을 한번 실행합니다.
   *   앱이 없으면 피드백X
   * 다운로드 버튼을 누르면 앱스토어/플레이스토어로 이동합니다
   */
  Appdownload = 'appdownload',
  /**
   * 웹에서 스킴을 지원한다면 해당 웹페이지가 뜹니다
   * 지원하지 않는다면 link 페이지가 뜹니다(linkpage 참고)
   */
  WebOrLinkpage = 'web-or-linkpage',
  /**
   * 웹에서 스킴을 지원한다면 해당 웹페이지가 뜹니다
   * 페이지가 뜬 뒤 scheme 을 한번 실행합니다.
   *   ios 는 앱이 없다면 ‘열 수 없는 페이지.. 어쩌구’ 가 뜨기 때문에 스킴 실행 전 팝업을 한번 띄워 물어봅니다
   *     카카오페이지 앱에서 감상하세요.\n앱으로 이동 하시겠습니까?
   * 안드로이드는 앱이 없으면 피드백X
   *지원하지 않는다면 앱다운로드 페이지가 뜹니다(appdownload 참고)
   */
  WebTryScheme = 'web-try-scheme',
  /**
   * 웹에서 스킴을 지원한다면 해당 웹페이지가 뜹니다
   * 페이지가 뜬 뒤 scheme 을 한번 실행합니다.
   *   앱이 없으면 피드백X
   * 지원하지 않는다면 link 페이지가 뜹니다(linkpage 참고)
   */
  WebTrySchemeOrLinkpage = 'web-try-scheme-or-linkpage',
  /**
   * 일반적으로 페이지웹 내에서만 사용하는 액션입니다
   * 앱스토어/플레이스토어가 뜹니다
   * PC에서 클릭 시 아무일도 일어나지 않으니 주의해서 사용
   */
  Store = 'store',
}
